import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { MatSelectionListChange } from "@angular/material/list";

@Component({
  selector: "transform-input",
  templateUrl: "./transform-input.component.html",
})
export class TransformInputComponent implements OnInit {

  @Input() public transformations: string[] = [];
  @Input() public switchs: any = {};
  private allTransformations: Map<string, TransformationsSection[]> = new Map([
    [ "file", [
      {
        name: "Transform value",
        allowMultiple: true,
        selected: [],
        transformations: [
          { name: "Gzip compress", value: "fromValueToGzip" },
          { name: "Base64 encode", value: "fromValueToBase64" },
        ],
      },
      {
        name: "Calculate value",
        allowMultiple: false,
        selected: [],
        transformations: [
          { name: "Calculate size", value: "fromValueToByteSize" },
        ],
      },
      {
        name: "Get property",
        allowMultiple: false,
        selected: [],
        transformations: [
          { name: "Random UUID", value: "getOptionalRandomUUID" },
          { name: "Original name", value: "getFileOriginalName" },
          { name: "Media type", value: "getFileMediaType" },
          { name: "Link", value: "getFileUrl" },
          { name: "Link and extension", value: "getFullUrl" },
        ],
      },
    ]],
    [ "fileupload", [
      {
        name: "Transform value",
        allowMultiple: true,
        selected: [],
        transformations: [
          { name: "Gzip compress", value: "fromValueToGzip" },
          { name: "Base64 encode", value: "fromValueToBase64" },
        ],
      },
      {
        name: "Calculate value",
        allowMultiple: false,
        selected: [],
        transformations: [
          { name: "Calculate size", value: "fromValueToByteSize" },
        ],
      },
      {
        name: "Get property",
        allowMultiple: false,
        selected: [],
        transformations: [
          { name: "Random UUID", value: "getOptionalRandomUUID" },
          { name: "Original name", value: "getFileOriginalName" },
          { name: "Media type", value: "getFileMediaType" },
          { name: "Link", value: "getFileUrl" },
          { name: "Link and extension", value: "getFullUrl" },
        ],
      },
    ]],
    [ "date", [
      {
        name: "Format date",
        allowMultiple: false,
        selected: [],
        transformations: [
          { name: "ISO Timestamp", value: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx" },
        ],
      },
    ]],
  ]);
  public availableTransformations: TransformationsSection[] = [];

  public ngOnInit() {
    if (!this.switchs.item.field.field.remoteType || !this.allTransformations.has(this.switchs.item.field.field.remoteType.toLowerCase())) {
      return;
    }
    this.availableTransformations = this.allTransformations.get(this.switchs.item.field.field.remoteType.toLowerCase());
    if (!this.switchs.item.field.targetFieldProperties || !this.switchs.item.field.targetFieldProperties.inputTransformations) {
      return;
    }
    this.switchs.item.field.targetFieldProperties.inputTransformations.forEach((value) => {
      this.availableTransformations.forEach((section) => {
        if (section.transformations.find((candidate) => candidate.value === value)) {
          section.selected.push(value);
        }
      });
    });
    this.setTransformations();
    this.sortAvailableTransformations();
  }

  private setTransformations() {
    this.transformations.length = 0;
    this.availableTransformations.forEach((section) => this.transformations.push(...section.selected));
  }

  private sortTransformations() {
    this.transformations.sort((a, b) => {
      for (const section of this.availableTransformations) {
        const ia = section.transformations.findIndex((transformation) => a === transformation.value);
        const ib = section.transformations.findIndex((transformation) => b === transformation.value);
        if (ia > -1) {
          return ib > -1 ? ia - ib : -1;
        }
        if (ib > -1) {
          return 1;
        }
      }
      return 0;
    });
  }

  private sortAvailableTransformations() {
    this.availableTransformations.forEach((section) => {
      if (!section.allowMultiple) {
        return;
      }
      section.transformations.sort((a, b) => {
        const aSelected = section.selected.includes(a.value);
        if (aSelected && section.selected.includes(b.value)) {
          return this.transformations.findIndex((value) => a.value === value) - this.transformations.findIndex((value) => b.value === value);
        }
        return aSelected ? -1 : 1;
      });
    });
  }

  public drop(event: CdkDragDrop<string[]>, section: TransformationsSection) {
    moveItemInArray(section.transformations, event.previousIndex, event.currentIndex);
    this.sortTransformations();
  }

  public onSelectChange(event: MatSelectionListChange, section: TransformationsSection) {
    if (section.allowMultiple) {
      this.availableTransformations.filter((i) => i !== section).forEach((i) => i.selected = []);
    } else {
      this.availableTransformations.forEach((i) => {
        const selectedOption = event.options.find(opt => opt.selected && opt.value === i);
        i.selected = selectedOption ? [selectedOption.value] : [];
      });
    }
    this.setTransformations();
    this.sortTransformations();
  }

}

class Transformation {
  public name: string;
  public value: string;
}

class TransformationsSection {
  public name: string;
  public allowMultiple: boolean;
  public selected: string[];
  public transformations: Transformation[];
}
